// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"bd6e1025","253":"0555deaa","254":"9e6dc896","432":"bd6e1025","630":"a6b185dd","775":"976aae30"}[chunkId] + ".chunk.css";
};